@if (presentation?.hasData) {
  <div class="multi-sample-container" [class.pdf-mode]="isPdfMode">
    @for (group of tableGroups; track trackByIndex(groupIndex); let groupIndex = $index) {
      <div class="table-container sample-info-table" [class.mt-4]="!group.isFirstGroup">
        <div class="concentration-header">
          <span class="units-label">[{{ group.concentrationsHeaderLabel }}]</span>
        </div>
        <table class="data-table">
          <thead>
            <tr>
              <th class="row-header">{{ group.sampleNumberLabel }} #:</th>
              @for (column of group.sampleColumns; track trackByIndex($index)) {
                <th class="sample-header">{{ column.sampleNumber }}
                </th>
              }
              @if (group.hasOelColumns) {
                <th [attr.colspan]="group.oelColumnCount" class="oel-header">{{ group.oelHeaderLabelLine1 }}<br>{{ group.oelHeaderLabelLine2 }}<br>{{ group.oelHeaderLabelLine3 }}</th>
              }
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="row-header">{{ group.jobTitleAreaLabel }}:</td>
              @for (column of group.sampleColumns; track trackByIndex($index)) {
                <td class="sample-value">{{ column.segName }}</td>
              }
              @for (oelColumn of group.oelColumns; track trackByIndex($index)) {
                <td [attr.rowspan]="10" class="oel-type-header" [style]="oelColumn.headerStyle">
                  <span class="oel-type-name">{{ oelColumn.oelTypeName }}</span>
                </td>
              }
            </tr>
            @for (fieldRow of group.fieldRows; track trackByIndex($index)) {
              <tr>
                <td class="row-header">{{ fieldRow.label }}</td>
                @for (value of fieldRow.values; track trackByIndex($index)) {
                  <td class="sample-value">{{ value }}
                  </td>
                }
              </tr>
            }
            <tr class="section-separator">
              <td class="separator-cell"></td>
              @for (column of group.sampleColumns; track trackByIndex($index)) {
                <td class="separator-cell"></td>
              }
            </tr>
            @for (displayTable of group.displayTables; track trackByIndex($index)) {
              @if (displayTable.showJurisdictionHeader) {
                <tr class="jurisdiction-header">
                  <td [attr.colspan]="group.sampleColumns.length + 1 + group.oelColumnCount" class="jurisdiction-header-cell">
                    <span class="jurisdiction-name">{{ displayTable.jurisdictionName }}</span>
                  </td>
                </tr>
              }
              @for (agent of displayTable.agentRows; track trackByIndex($index)) {
                <tr>
                  <td class="agent-name">{{ agent.agentName }}</td>
                  @for (cell of agent.sampleCells; track trackByIndex($index)) {
                    <td class="sample-value" [style]="cell.cellStyle">{{ cell.display }}</td>
                  }
                  @for (cell of agent.oelCells; track trackByIndex($index)) {
                    <td class="oel-value" [style]="cell.cellStyle">{{ cell.display }}</td>
                  }
                </tr>
              }
            }
          </tbody>
        </table>
        @if (group.hasLegend) {
          <div class="table-legend">
            @for (item of group.legendItems; track trackByIndex($index)) {
              <span class="legend-item">
                <span class="legend-color" [style]="item.swatchStyle"></span>
                &gt; {{ item.legendText }}
              </span>
            }
          </div>
        }
      </div>
    }
    <div class="table-container task-area-table">
      <table class="data-table task-table">
        <tbody>
          @for (row of taskAreaRows; track trackByIndex($index)) {
            <tr>
              <td class="sample-number">
                <div class="sample-label">{{ presentation?.sampleNumberLabel }} #:</div>
                <div class="sample-value">{{ row.sampleNumber }}</div>
              </td>
              <td class="task-area">
                <div class="task-label">{{ presentation?.taskAreaLabel }}:</div>
                <div class="task-description">{{ row.taskDescription }}
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
}
